import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { PowerBiApiType } from "./types/apiTypes";

const powerBiApi: PowerBiApiType = {
  authenticate: (dashboardId) => apiClient.get(endPoints.powerBi.authenticate(dashboardId)),
};

export default powerBiApi;
